import LeftRailNavigation from './LeftRailNavigation';
import './LeftRailNavigation.scss';

export default LeftRailNavigation;
